<template>
    
    <article class="parution">
            
            <header class="parution--header" data-cursor-mix-blend-mode="difference">
                <div class="parution--title-wrap">
                    <h1 class="parution--title" v-bind:class="{ 'xs': isLongTitle(article.title) }">{{ article.title }}</h1>
                </div>
                <div class="parution--cover" :style="`box-shadow: 0px 32px 44px 0px ${hexToRgbA(article.product.color, 0.2)}`">
                    <img
                    :src="require(`@/assets/images/articles/${article.product.covers.large}`)"
                    alt="">
                </div>
                
                <div class="parution--background" :style="`background-color: ${article.product.color}`"></div>
            </header>
            <section class="parution--details">
                <div class="parution--details-wrap">
                    <div class="parution--details-excerpt" v-html="article.product.excerpt"></div>
                    <router-link class="parution--read-more" :to="{ name: 'ParutionExtrait' }">
                        Lire un extrait
                    </router-link>
                    <div class="parution--details-publication">
                        <ul>
                            <li><strong>Éditions</strong> {{ article.product.editions }}</li>
                            <li><strong>Paru le</strong> {{ article.product.editions }}</li>
                        </ul>
                    </div>
                    <div class="parution--details-prices">
                        <div class="parution--details-prices-format" v-for="format in article.product.prices" :key="format.id">
                            <span class="price">{{ format.price }}</span>
                            <span class="format">{{ format.format }}</span>
                        </div>
                    </div>
                    <div class="parution--details-buy">
                        <a :href="`${ article.product.buy_link }`" target="_blank" rel="noopener">Acheter</a>
                        <svg width="182" height="55" xmlns="http://www.w3.org/2000/svg">
                            <path d="M180.723 9.106a232.698 232.698 0 00-34.187-6.775A239.636 239.636 0 00111.688.667 238.195 238.195 0 0077.07 4.073a235.344 235.344 0 00-33.874 8.467 227.005 227.005 0 00-16.269 6.085c-6.165 2.581-12.3 5.456-17.685 9.444-4.499 3.33-10.857 8.57-7.579 14.834 1.458 2.786 4.163 4.82 6.891 6.265 2.948 1.561 6.2 2.491 9.438 3.22 12.937 2.908 26.31 2.908 39.464 2.292a487.27 487.27 0 0041.605-3.75c13.21-1.761 26.543-3.764 39.354-7.466 6.212-1.795 12.294-4.05 18.057-6.975 2.49-1.263 5.684-2.698 6.612-5.58.994-3.085-1.516-5.95-3.682-7.858-2.348-2.07-5.224-3.478-8.277-4.122-1.417-.3-1.787 1.911-.37 2.21a15.954 15.954 0 017.911 4.28c.943.932 2.05 2.133 2.352 3.462.283 1.244-.472 2.332-1.37 3.104-1.084.932-2.39 1.585-3.653 2.24a80.83 80.83 0 01-4.16 1.997 100.624 100.624 0 01-8.79 3.435c-12.119 4.116-24.853 6.234-37.497 8.098a489.569 489.569 0 01-40.316 4.247c-12.911.822-25.981 1.39-38.86-.386-3.142-.434-6.276-.996-9.36-1.757-3.063-.756-6.142-1.772-8.828-3.474-2.259-1.43-4.871-3.666-5.19-6.499-.316-2.8 1.896-5.098 3.77-6.856 4.728-4.436 10.52-7.636 16.39-10.313 5.266-2.4 10.673-4.516 16.127-6.455A230.411 230.411 0 0171.86 7.31a237.583 237.583 0 0133.424-4.15 236.052 236.052 0 0133.642.616 233.483 233.483 0 0133.515 5.49 232.98 232.98 0 017.912 2.05c.586.163 1.2-.357 1.293-.912.108-.646-.335-1.135-.923-1.299" fill="#F52770" fill-rule="evenodd"/>
                        </svg>
                    </div>
                    <div class="mentions">
                        Détails et livraisons sur Amazon.fr
                    </div>
                </div>
            </section>
            <router-view :key="$route.path" />
            <GoBack />
        </article>
</template>
<script>
import articlesJSON from '@/content.js';

export default {
    //name: "article",
    data() {
        return {
        
        }
    },
    props: {
        slug: {
            type: String,
            required: true
        }
    },
    computed: {
        article(){
            return articlesJSON.articles.find(
                article => article.slug === this.slug
            )
        },
    },
    methods: {
        isLongTitle($title){
            if($title.length > 7){
                return true
            }
        },
        hexToRgbA(hex, alpha){
            var r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);

            if (alpha) {
                return "rgba(" + r + ", " + g + ", " + b + ", " + alpha + ")";
            } else {
                return "rgb(" + r + ", " + g + ", " + b + ")";
            }
        }
    },
    mounted() {
        //document.getElementById('app').scrollIntoView();
        window.componentInstance.setBackground('offwhite');
    },
    updated(){

    },
    beforeDestroy() {
        
    }
  }
</script>
<style lang="scss" scoped>
  @import "@/assets/styles/sass/templates/_parution.scss";

  .coucou-enter-active,
.coucou-leave-active{
  transition: opacity 1s;
}

/*.coucou-enter-to,
.coucou-leave{
  opacity: 1;
}*/

.coucou-enter,
.coucou-leave-to{
  opacity: 0;
}

</style>